<template>
  <Form style="line-height:32px"
        :model="formdata"
        :label-width="120"
        inline
        ref="form">
    <div class="color-error text-center">{{$t('erp.b2c.approved_desc',{defaultValue:'确定审核该订单？审核通过后，订单会自动进入订单处理流程'})}}</div>
    <FormItem :label="$t('global.common.notes',{defaultValue:'备注'})"
              style="width:90%">
      <vTextarea v-model="formdata.remark"
                 :rows="3"
                 type="textarea" />
    </FormItem>
    <footer class="text-right">
      <Button type="primary"
              @click="submit">{{$t('global.common.save',{defaultValue:'保存'})}}</Button>
      <Button class="margin-left-10"
              @click="cancel">{{$t('global.common.cancel',{defaultValue:'取消'})}}</Button>
    </footer>
    <Spin size="large"
          fix
          v-if="loading"></Spin>
  </Form>
</template>
<script>
import {
  HttptoExamine
} from '@/service/boss/b2corder'
export default {
  props: ['activeids'],
  data () {
    return {
      loading: false,
      formdata: {
        remark: "",
      },
    }
  },
  methods: {
    cancel () {
      this.$emit('on-close')
    },
    async submit () {
      // let data = await this.$refs['form'].validate();
      // if (!data) return;
      this.loading = true;
      HttptoExamine({
        orderIds: this.activeids,
        remark: this.formdata.remark
      }).then(res => {
        this.$Message.success(res.message);
        this.cancel();
        this.$emit('on-update');
      }, err => {
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>
